module.exports = ".cart-widget {\n    display: inline-block;\n    padding: 3px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/cart-widget/cart-widget.component.css
// module id = ./src/app/admin/cart-widget/cart-widget.component.css
// module chunks = main